import * as React from 'react';
import { Responsive } from '@cian/ui-kit/responsive';

import { ValuationFiltersMobile } from './views/mobile';
import { ValuationFiltersDesktop } from './views/desktop';
import { IValuationFiltersProps } from './types/public';

export const ValuationFilters: React.FC<IValuationFiltersProps> = props => {
  return (
    <React.Fragment>
      <Responsive desktop>
        <ValuationFiltersDesktop {...props} />
      </Responsive>
      <Responsive tablet phone>
        <ValuationFiltersMobile {...props} />
      </Responsive>
    </React.Fragment>
  );
};
